import { useCashSession } from "../../hooks/cash/useCashSession";
import Spinner from "../Spinners/Spinner";

const CashOpeningActions = () => {
  const { openingForm, loading, submitOpeningSession } = useCashSession();

  const total = openingForm.openingAmount || 0;

  return (
    <div className="rounded-sm border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Total contado
          </p>

          <p className="text-2xl font-bold text-primary">
            ${total.toFixed(2)}
          </p>
        </div>

        <button
          onClick={submitOpeningSession}
          disabled={loading}
          className={`flex items-center gap-2 rounded-md px-6 py-3 text-sm font-medium text-white shadow-sm transition
            ${loading
              ? "cursor-not-allowed bg-gray-400"
              : "bg-primary hover:bg-opacity-90"
            }`}
        >
          {loading && <Spinner size={20} color="white" />}
          {loading ? "Procesando..." : "Abrir Caja"}
        </button>
      </div>
    </div>
  );
};

export default CashOpeningActions;